import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';

const searchByTerm = async (search, establecimientoId ) => {

  if(!establecimientoId){
    console.error("establecimientoId es required");
    return null;
  }

  const query = `
    query GetAllitemOdontologicos($search: String, $establecimiento: String) {
                allOdonto(search: $search, establecimiento: $establecimiento) {
                    total
                    status
                    message
                    itemOdontologico{
                        id
                        token
                        descripcion
                        establecimiento
                      	especialidad {
                          id
                          descripcion
                        }
                        usuarioCreador {
                            id
                            username
                        }
                        codigo
                        estado
                        precio
                        precioJson
                        estadoJson
                    }
                    pageInfo {
                        currentPage
                        totalPages
                        hasNextPage
                        hasPreviousPage
                    }
                }
            }

            
  `;

  const variables = {
    search,
    establecimiento : establecimientoId,
    estado : '1'
  };

  try {

    const response = await axios.post(rutas.axios + 'api', { query, variables });
    const response2 = response.data.data.allOdonto;


    if( response2.itemOdontologico.length === 0 ) return null;

    const data = response2.itemOdontologico;

    const dataMap = data.map(item => ({
      ...item,
      text: item.descripcion,
      value: item.id
    }));
    
    return dataMap

  } catch (error) {
    console.error(error);
    return error;
  }
}

export const odontoServices = {
  searchByTerm
}
